import { Switch, type SwitchProps } from 'antd';
import { Controller, useFormContext } from 'react-hook-form';

interface ISwitchProp extends SwitchProps {
  fieldName: string;
}

export const SwitchField = ({ fieldName, ...restProps }: ISwitchProp) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field }) => (
        <Switch
          {...field}
          {...restProps}
        />
      )}
    />
  );
};
